import RdaDrawer from './RdaDrawer'
import { useTranslation } from 'react-i18next'
import AssetDrawerScope from './AssetDrawerScope'
import { PrimaryButton } from './formKit'

/**
 * The redesign's version of the classic `FirstTimeDialog`: the "what is
 * this?" explainer a first-time visitor sees on the home, or reopens from the
 * header's info button. Same copy, same localStorage flag
 * (`firsttime_dialog_shown`, set by `useHomeModel`'s `closeFirstTime`), in the
 * design's bottom sheet rather than the classic centered dialog.
 */
export default function FirstTimeSheet({
  accent,
  show,
  close,
}: {
  accent: string
  show: boolean
  close: () => void
}) {
  const { t } = useTranslation()
  return (
    <RdaDrawer
      title={t('home.whatIsThis.title')}
      isOpen={show}
      placement="bottom"
      height="auto"
      onClose={close}
      onRequestClose={close}
    >
      <AssetDrawerScope fit accent={accent}>
        <div className="mx-auto flex w-full max-w-xl flex-col gap-4">
          <p className="text-sm leading-relaxed text-[var(--rda-muted)] sm:text-[15px]">
            {t('home.whatIsThis.paragraph1')}
          </p>
          <p className="text-sm leading-relaxed text-[var(--rda-muted)] sm:text-[15px]">
            {t('home.whatIsThis.paragraph2')}
          </p>
          <PrimaryButton className="rounded-lg sm:rounded-xl" onClick={close}>
            {t('home.whatIsThis.continue')}
          </PrimaryButton>
        </div>
      </AssetDrawerScope>
    </RdaDrawer>
  )
}
